const FULBIX_VISUAL_STYLE_ID = 'size-required-fulbix-visual-style';
const CTA_DEFAULT_TEXT = 'In winkelwagen';
const SIZE_REQUIRED_TEXT = '⚠ Kies eerst je maat';
const SIZE_REQUIRED_DURATION = 4500;
const SIZE_BLINK_CLASS = 'size-required-grey-blink';
const confirmedSizeByForm = new WeakMap();
const variantReadyByForm = new WeakMap();
const variantAvailableByForm = new WeakMap();
const lastPriceByForm = new WeakMap();
const discountedPriceByForm = new WeakMap();
const sizeRequiredTimerByForm = new WeakMap();
const ctaObserverByForm = new WeakMap();
const ctaWritingByForm = new WeakSet();
let fulbixVisualObserver = null;
let fulbixVisualFrame = 0;


/* =========================================================
   PRODUCT / SIZE HELPERS
   ========================================================= */

function getProductForm(element) {
  if (!(element instanceof Element)) return null;

  const section = element.closest('.shopify-section');
  const scopedForm = section?.querySelector(
    'product-form-component'
  );

  if (scopedForm) return scopedForm;

  const mainForms = document.querySelectorAll(
    'main product-form-component'
  );

  return mainForms.length === 1
    ? mainForms[0]
    : null;
}


function getSizeInputs(productForm) {
  const section = productForm?.closest(
    '.shopify-section'
  );

  return Array.from(
    section?.querySelectorAll(
      'variant-picker input[data-option-name="Size" i]'
    ) ?? []
  );
}


function getSelectedSizeInput(productForm) {
  return (
    getSizeInputs(productForm).find(
      (input) => input.checked
    ) ?? null
  );
}


function getAddButton(productForm) {
  return (
    productForm?.querySelector(
      'button[name="add"]'
    ) ?? null
  );
}


/* =========================================================
   CTA
   ========================================================= */

function setButtonText(button, text) {
  const textNode = Array.from(
    button.childNodes
  ).find(
    (node) =>
      node.nodeType === Node.TEXT_NODE &&
      node.textContent.trim() !== ''
  );

  if (
    textNode &&
    textNode.textContent.trim() !== text
  ) {
    textNode.textContent = text;
  }
}

function extractCurrentPrice(root) {
  const container = root?.querySelector?.(
    'product-price [ref="priceContainer"]'
  );

  if (!container) return '';

  const price =
    container.querySelector(
      '.price-item__group.price'
    ) ||
    Array.from(container.children).find(
      (element) =>
        element.matches?.('.price')
    ) ||
    container.querySelector('.price');

  if (!price) return '';

  const clone = price.cloneNode(true);

  clone
    .querySelectorAll('.visually-hidden')
    .forEach((element) => element.remove());

  return clone.textContent
    .replace(/\s+/g, ' ')
    .trim();
}


function refreshCurrentPrice(productForm, root = null) {
  const section = productForm?.closest(
    '.shopify-section'
  );

  const price =
    extractCurrentPrice(root) ||
    extractCurrentPrice(section);

  if (price) {
    lastPriceByForm.set(
      productForm,
      price
    );
  }

  return (
    lastPriceByForm.get(productForm) ??
    ''
  );
}


function getNormalCTAText(productForm) {
  const discountedPrice =
    discountedPriceByForm.get(
      productForm
    );

  if (discountedPrice) {
    return `${CTA_DEFAULT_TEXT} · ${discountedPrice}`;
  }

  const price =
    refreshCurrentPrice(productForm);

  return price
    ? `${CTA_DEFAULT_TEXT} · ${price}`
    : CTA_DEFAULT_TEXT;
}
function getDesiredCTAText(productForm) {
  /*
   * Si le message demandant la Size est actif,
   * il reste prioritaire.
   */
  if (
    sizeRequiredTimerByForm.has(productForm)
  ) {
    return SIZE_REQUIRED_TEXT;
  }

  return getNormalCTAText(productForm);
}


function stabilizeCTA(productForm) {
  if (!productForm) return;

  const button = getAddButton(productForm);

  if (!button) return;

  /*
   * Un véritable ajout panier est en cours :
   * ne jamais perturber l'animation native Horizon.
   */
  if (button.dataset.added === 'true') {
    return;
  }

  /*
   * Si Horizon vient de désactiver le bouton,
   * la variante est Sold Out / Unavailable.
   * On ne force rien.
   */
  if (button.disabled) {
    variantAvailableByForm.set(
      productForm,
      false
    );

    return;
  }

  /*
   * Le bouton natif est actif :
   * la variante est disponible.
   */
  variantAvailableByForm.set(
    productForm,
    true
  );

  setButtonText(
    button,
    getDesiredCTAText(productForm)
  );
}


function startCTAStabilityObserver(productForm) {
  if (
    !productForm ||
    ctaObserverByForm.has(productForm)
  ) {
    return;
  }

  const observer =
    new MutationObserver(() => {
      /*
       * Empêche notre propre correction
       * d'être traitée comme une nouvelle
       * modification externe.
       */
      if (
        ctaWritingByForm.has(productForm)
      ) {
        return;
      }

      ctaWritingByForm.add(productForm);

      stabilizeCTA(productForm);

      queueMicrotask(() => {
        ctaWritingByForm.delete(
          productForm
        );
      });
    });

  /*
   * Observation limitée uniquement
   * au formulaire produit.
   *
   * Pas d'observer global sur document.body.
   */
  observer.observe(productForm, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  ctaObserverByForm.set(
    productForm,
    observer
  );
}
function clearSizeRequiredTimer(productForm) {
  const timer =
    sizeRequiredTimerByForm.get(productForm);

  if (timer) {
    clearTimeout(timer);
  }

  sizeRequiredTimerByForm.delete(productForm);
}


function showDefaultCTA(productForm) {
  const button = getAddButton(productForm);

  if (!button) return;
  if (
    variantAvailableByForm.get(productForm) === false
  ) {
    return;
  }
  button.disabled = false;
button.dataset.puppet = 'false';
  setButtonText(
    button,
    getNormalCTAText(productForm)
  );

  setFulbixSizeLabel(productForm, null);
}


function getSizeAttentionButtons(productForm) {
  const section = productForm?.closest(
    '.shopify-section'
  );

  if (!section) return [];

  const fulbixSizeOption = Array.from(
    section.querySelectorAll('.fulbix-option')
  ).find(isFulbixSizeOption);

  if (fulbixSizeOption) {
    return Array.from(
      fulbixSizeOption.querySelectorAll(
        '.fulbix-swatch'
      )
    );
  }

  return getSizeInputs(productForm)
    .map((input) => input.closest('label'))
    .filter(Boolean);
}


function ensureSizeBlinkStyle() {
  const styleId =
    'size-required-grey-blink-style';

  if (document.getElementById(styleId)) {
    return;
  }

  const style =
    document.createElement('style');

  style.id = styleId;

  style.textContent = `
    @keyframes sizeRequiredGreyBlink {
      0%,
      100% {
        filter: brightness(1);
      }

      16% {
        filter: brightness(.76);
      }

      32% {
        filter: brightness(1);
      }

      48% {
        filter: brightness(.76);
      }

      64% {
        filter: brightness(1);
      }

      80% {
        filter: brightness(.76);
      }
    }

    .${SIZE_BLINK_CLASS} {
      animation:
        sizeRequiredGreyBlink
        1.65s
        cubic-bezier(.4, 0, .2, 1)
        both;
    }

    @media (prefers-reduced-motion: reduce) {
      .${SIZE_BLINK_CLASS} {
        animation: none;
        filter: brightness(.84);
      }
    }
  `;

  document.head.appendChild(style);
}


function blinkSizeButtons(productForm) {
  ensureSizeBlinkStyle();

  const buttons =
    getSizeAttentionButtons(productForm);

  buttons.forEach((button) => {
    button.classList.remove(
      SIZE_BLINK_CLASS
    );
  });

  const section =
    productForm.closest('.shopify-section');

  if (section) {
    void section.offsetWidth;
  }

  buttons.forEach((button) => {
    button.classList.add(
      SIZE_BLINK_CLASS
    );
  });

  setTimeout(() => {
    buttons.forEach((button) => {
      button.classList.remove(
        SIZE_BLINK_CLASS
      );
    });
  }, 1750);
}
function stopSizeBlink(productForm) {
  getSizeAttentionButtons(productForm)
    .forEach((button) => {
      button.classList.remove(
        SIZE_BLINK_CLASS
      );
    });
}

function showSizeRequired(productForm) {
  const button = getAddButton(productForm);

  if (!button) return;

  clearSizeRequiredTimer(productForm);

  /*
   * Empêche le faux check + fly-to-cart
   * lorsqu'aucune Size valide n'existe.
   */
  button.dataset.puppet = 'true';
  button.removeAttribute('data-added');

  document
    .querySelectorAll('fly-to-cart')
    .forEach((element) => element.remove());

  button.disabled = false;

  setButtonText(
    button,
    SIZE_REQUIRED_TEXT
  );

  blinkSizeButtons(productForm);

  /*
   * Le clic courant est terminé avant
   * de rendre le feedback Horizon disponible.
   */
  setTimeout(() => {
    const currentButton =
      getAddButton(productForm);

    if (currentButton) {
      currentButton.dataset.puppet = 'false';
    }
  }, 0);

  const timer = setTimeout(() => {
    showDefaultCTA(productForm);

    sizeRequiredTimerByForm.delete(
      productForm
    );
  }, SIZE_REQUIRED_DURATION);

  sizeRequiredTimerByForm.set(
    productForm,
    timer
  );
}

function showSelectSize(productForm) {
  if (
    !productForm ||
    getSizeInputs(productForm).length === 0
  ) {
    return;
  }

  /*
   * Si Horizon vient d'indiquer
   * Sold Out / Unavailable,
   * on ne touche pas au CTA.
   */
  if (
    variantAvailableByForm.get(productForm) === false
  ) {
    return;
  }

  showDefaultCTA(productForm);
}


function showAddToCart(productForm) {
  const button = getAddButton(productForm);

  if (!button) return;
    if (
    variantAvailableByForm.get(productForm) === false
  ) {
    return;
  }
    clearSizeRequiredTimer(productForm);
  stopSizeBlink(productForm);

  button.dataset.puppet = 'false';

  button.disabled = false;

  setButtonText(
    button,
    getNormalCTAText(productForm)
  );

  const confirmedSize =
    confirmedSizeByForm.get(productForm) ??
    getSelectedSizeInput(productForm)?.value ??
    null;

  setFulbixSizeLabel(productForm, confirmedSize);
}


function sizeInputIsAvailable(input) {
  return Boolean(
    input &&
      input.dataset.optionAvailable !== 'false' &&
      input.getAttribute('aria-disabled') !== 'true' &&
      !input.disabled
  );
}


/* =========================================================
   FULBIX DETECTION
   ========================================================= */

function isFulbixSizeOption(option) {
  if (!(option instanceof Element)) {
    return false;
  }

  const label = option.querySelector(
    '.fulbix-option-label'
  );

  const text = (
    label?.textContent ?? ''
  ).trim();

  return /^size\s*:?/i.test(text);
}
function decorateFulbixSizeLabel(label) {
  if (!(label instanceof Element)) {
    return;
  }

  if (
    label.querySelector(
      '.aurreva-selected-size-badge'
    )
  ) {
    return;
  }

  const match = label.textContent
    .trim()
    .match(/^size\s*:\s*(.+)$/i);

  if (!match) {
    return;
  }

  const sizeValue = match[1].trim();

  if (
    !sizeValue ||
    /^select$/i.test(sizeValue)
  ) {
    return;
  }

  const badge =
    document.createElement('span');

  badge.className =
    'aurreva-selected-size-badge';

  badge.textContent = sizeValue;

  label.replaceChildren(
    document.createTextNode('Size:'),
    badge
  );
}

function syncDutchFulbixOptionLabel(label) {
  if (!(label instanceof Element)) {
    return;
  }

  const text = label.textContent
    .replace(/\s+/g, ' ')
    .trim();

  /*
   * Sauvegarder le style original AVANT
   * que le CSS mette font-size à 0.
   */
  if (
    !label.style.getPropertyValue(
      '--aurreva-label-size'
    )
  ) {
    const computed =
      getComputedStyle(label);

    label.style.setProperty(
      '--aurreva-label-size',
      computed.fontSize
    );

    label.style.setProperty(
      '--aurreva-label-line-height',
      computed.lineHeight
    );

    label.style.setProperty(
      '--aurreva-label-color',
      computed.color
    );
  }

  /*
   * Color reste techniquement "Color".
   * Seul l'affichage devient
   * "Gekozen kleur".
   */
  const colorMatch =
    text.match(/^color\s*:\s*(.+)$/i);

  if (colorMatch) {
    label.dataset.aurrevaNl = 'color';
    label.dataset.aurrevaValue =
      colorMatch[1].trim();

    return;
  }

  /*
   * Size reste techniquement "Size".
   * Seul l'affichage devient
   * "Gekozen maat".
   */
  if (/^size\s*:/i.test(text)) {
    label.dataset.aurrevaNl = 'size';

    delete label.dataset.aurrevaValue;

    return;
  }
}


function syncDutchFulbixOptionLabels(
  root = document
) {
  root
    .querySelectorAll(
      '.fulbix-option-label'
    )
    .forEach(
      syncDutchFulbixOptionLabel
    );
}


function setFulbixSizeLabel(productForm, sizeValue = null) {
  if (!productForm) return;

  const section = productForm.closest('.shopify-section');
  if (!section) return;

  const sizeOption = Array.from(
    section.querySelectorAll('.fulbix-option')
  ).find(isFulbixSizeOption);

  const label = sizeOption?.querySelector('.fulbix-option-label');
  if (!label) return;

  label.textContent = sizeValue
    ? `Size: ${sizeValue}`
    : 'Size: Select';

    decorateFulbixSizeLabel(label);
  syncDutchFulbixOptionLabel(label);
}

function isFulbixSizeSwatch(swatch) {
  const option = swatch.closest(
    '.fulbix-option'
  );

  return isFulbixSizeOption(option);
}


/* =========================================================
   FULBIX INITIAL VISUAL FIX

   Horizon = aucune Size checked
   => aucune Size FulbiX ne doit paraitre selectionnee.

   Nous ne modifions PAS les styles inline FulbiX.
   Nous appliquons seulement une couche visuelle
   conditionnelle.
   ========================================================= */

function ensureFulbixVisualStyle() {
  if (
    document.getElementById(
      FULBIX_VISUAL_STYLE_ID
    )
  ) {
    return;
  }

  const style =
    document.createElement('style');

  style.id =
    FULBIX_VISUAL_STYLE_ID;

  style.textContent = `
  body:not(:has(
    variant-picker
    input[data-option-name="Size" i]:checked
  ))
  .fulbix-option[data-size-required-option="true"]
  .fulbix-swatch {
    background-color:
      var(--size-unselected-bg) !important;

    color:
      var(--size-unselected-color) !important;

    border:
      var(--size-unselected-border) !important;

    box-shadow:
      var(--size-unselected-shadow) !important;
  }
      .fulbix-option[data-size-required-option="true"]
.fulbix-swatch--pill {
  box-sizing: border-box !important;
  width: auto !important;
  min-width: 54px !important;
  max-width: none !important;
  flex: 0 0 auto !important;
  border-radius: 0 !important;
  white-space: nowrap !important;
}
`;

  document.head.appendChild(style);
}


function prepareFulbixSizeOption(option) {
  if (!isFulbixSizeOption(option)) {
    return;
  }
    const productForm = getProductForm(option);
  const confirmedSize = productForm
    ? confirmedSizeByForm.get(productForm)
    : null;

  if (productForm) {
    setFulbixSizeLabel(productForm, confirmedSize ?? null);
  }

  const section = option.closest(
    '.shopify-section'
  );

  const nativeSizeChecked =
    section?.querySelector(
      'variant-picker input[data-option-name="Size" i]:checked'
    );

  /*
   * Si Horizon possède déjà une vraie Size sélectionnée,
   * on ne touche pas à l'affichage FulbiX.
   */
  if (nativeSizeChecked) {
    return;
  }

  const swatches = Array.from(
    option.querySelectorAll(
      '.fulbix-swatch'
    )
  );

  /*
   * FulbiX sélectionne visuellement la première Size.
   * Nous utilisons donc la deuxième comme référence
   * visuelle d'un bouton non sélectionné.
   */
  if (swatches.length < 2) {
    return;
  }

  const reference = swatches[1];

  const computed =
    getComputedStyle(reference);

  option.dataset.sizeRequiredOption =
    'true';


  option.style.setProperty(
    '--size-unselected-bg',
    reference.style.backgroundColor ||
      computed.backgroundColor
  );


  option.style.setProperty(
    '--size-unselected-color',
    reference.style.color ||
      computed.color
  );


  option.style.setProperty(
    '--size-unselected-border',
    reference.style.border ||
      computed.border
  );


  option.style.setProperty(
    '--size-unselected-shadow',
    reference.style.boxShadow ||
      computed.boxShadow
  );
}


function initFulbixSizeVisualFix(
  root = document
) {
  ensureFulbixVisualStyle();

    syncDutchFulbixOptionLabels(root);

  root
    .querySelectorAll(
      '.fulbix-option'
    )
    .forEach(
      prepareFulbixSizeOption
    );
}


function scheduleFulbixSizeVisualFix() {
  if (fulbixVisualFrame) {
    return;
  }

  fulbixVisualFrame =
    requestAnimationFrame(() => {
      fulbixVisualFrame = 0;

      initFulbixSizeVisualFix();
    });
}


/*
 * FulbiX peut rendre ses swatches après le chargement
 * initial. On surveille uniquement l'ajout de ses
 * composants, pas les attributs de toute la page.
 */
function startFulbixVisualObserver() {
  if (
    fulbixVisualObserver ||
    !document.body
  ) {
    return;
  }

  fulbixVisualObserver =
    new MutationObserver(
      (mutations) => {

        const fulbixChanged =
          mutations.some(
            (mutation) =>
              Array.from(
                mutation.addedNodes
              ).some(
                (node) =>
                  node instanceof Element &&
                  (
                    node.matches(
                      '.fulbix-option, .fulbix-swatch'
                    ) ||
                    node.querySelector?.(
                      '.fulbix-option, .fulbix-swatch'
                    )
                  )
              )
          );

          mutations.forEach((mutation) => {
  const target = mutation.target;

  if (
    target instanceof Element &&
    target.matches(
      '.fulbix-option-label'
    )
  ) {
    decorateFulbixSizeLabel(
      target
    );
  }
});

        if (fulbixChanged) {
          scheduleFulbixSizeVisualFix();
        }
      }
    );

  fulbixVisualObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
}


/* =========================================================
   REAL CUSTOMER SIZE INTERACTION
   ========================================================= */

function confirmSizeInteraction(target) {
  if (!(target instanceof Element)) {
    return;
  }


  /*
   * Maathulp recommendation CTA.
   *
   * The click itself is trusted customer intent.
   * The actual variant selection happens afterwards
   * through FulbiX and Horizon.
   */
  const advisorChoice =
    target.closest(
      '[data-maathulp-size-choice]'
    );

  if (advisorChoice) {
    const productForm =
      getProductForm(
        advisorChoice
      );

    const sizeValue =
      advisorChoice.dataset
        .maathulpSizeChoice
        ?.trim();

    const matchingInput =
      getSizeInputs(productForm)
        .find(
          (input) =>
            input.value === sizeValue
        );

    if (
      productForm &&
      sizeValue &&
      sizeInputIsAvailable(
        matchingInput
      )
    ) {
      confirmedSizeByForm.set(
        productForm,
        sizeValue
      );
    }

    return;
  }


  /*
   * Fallback natif Horizon.
   */
  const nativeSizeInput =
    target.closest(
      'input[data-option-name="Size" i]'
    );

  if (nativeSizeInput) {
    const productForm =
      getProductForm(
        nativeSizeInput
      );

    if (productForm) {
      confirmedSizeByForm.set(
        productForm,
        nativeSizeInput.value
      );
    }

    return;
  }


  /*
   * FulbiX Size swatch.
   */
  const swatch =
    target.closest(
      '.fulbix-swatch'
    );

  if (
    !swatch ||
    !isFulbixSizeSwatch(swatch)
  ) {
    return;
  }


  const productForm =
    getProductForm(swatch);

  const sizeValue =
    swatch.dataset.value?.trim();


  if (
    !productForm ||
    !sizeValue
  ) {
    return;
  }


  const selectedBeforeClick =
    getSelectedSizeInput(
      productForm
    );


  /*
   * À partir de cet instant,
   * cette Size est considérée comme
   * réellement choisie par la cliente.
   */
  confirmedSizeByForm.set(
    productForm,
    sizeValue
  );


  /*
   * Si la cliente reclique une Size
   * déjà réellement sélectionnée,
   * ce clic reste une confirmation valide.
   */
  if (
    selectedBeforeClick?.value ===
      sizeValue &&
    sizeInputIsAvailable(
      selectedBeforeClick
    )
  ) {
    showAddToCart(
      productForm
    );
  }
}


function handleClick(event) {
  /*
   * Les actions automatiques FulbiX
   * ne comptent jamais comme choix client.
   */
  if (!event.isTrusted) {
    return;
  }

  /*
   * Conserver la détection existante
   * d'un vrai clic sur une Size.
   */
  confirmSizeInteraction(
    event.target
  );

  const clickedButton =
    event.target instanceof Element
      ? event.target.closest(
          'button[name="add"]'
        )
      : null;

  if (!clickedButton) {
    return;
  }

  const productForm =
    getProductForm(clickedButton);

  if (
    !productForm ||
    clickedButton !==
      getAddButton(productForm) ||
    getSizeInputs(productForm).length === 0
  ) {
    return;
  }

  const confirmedSize =
    confirmedSizeByForm.get(
      productForm
    );

  const selectedSize =
    getSelectedSizeInput(
      productForm
    )?.value ?? null;

  const variantReady =
    variantReadyByForm.get(
      productForm
    ) === true;

  /*
   * Vrai choix client + variante résolue :
   * Horizon peut poursuivre normalement.
   */
  if (
    confirmedSize &&
    selectedSize === confirmedSize &&
    variantReady
  ) {
    return;
  }

  /*
   * Sinon aucun Add To Cart n'est autorisé.
   */
  event.preventDefault();
  event.stopImmediatePropagation();

  showSizeRequired(productForm);
}


function handleKeydown(event) {
  if (
    !event.isTrusted ||
    (
      event.key !== 'Enter' &&
      event.key !== ' '
    )
  ) {
    return;
  }

  confirmSizeInteraction(
    event.target
  );
}


/* =========================================================
   HORIZON VARIANT UPDATE
   ========================================================= */

async function handleProductSelect(event) {
  const productForm =
    getProductForm(
      event.target
    );


  if (
    !productForm ||
    getSizeInputs(
      productForm
    ).length === 0
  ) {
    return;
  }
  variantReadyByForm.set(
    productForm,
    false
  );

  try {

    /*
     * Attendre que Horizon termine réellement
     * la résolution et le rendu de variante.
     */
    const result =
      event.promise
        ? await event.promise
        : null;
    if (result?.detail) {
      const isAvailable =
        result.detail.resource?.available === true;

      variantAvailableByForm.set(
        productForm,
        isAvailable
      );

      /*
       * Récupère le prix du nouveau rendu Shopify.
       * Exemple :
       * Red €45 -> Black €49
       * le CTA suivra automatiquement.
       */
      refreshCurrentPrice(
        productForm,
        result.detail.html
      );

      /*
       * Si la nouvelle combinaison est
       * indisponible, on arrête également
       * tout ancien message/animation Size.
       */
      if (!isAvailable) {
        clearSizeRequiredTimer(
          productForm
        );

        stopSizeBlink(
          productForm
        );
      }
    }

        scheduleFulbixSizeVisualFix();

    const confirmedSize =
      confirmedSizeByForm.get(
        productForm
      );


    if (!confirmedSize) {
  /*
   * Aucune Size n'a encore été choisie
   * volontairement par la cliente.
   */
  showSelectSize(
    productForm
  );

  scheduleFulbixSizeVisualFix();

  /*
   * FulbiX peut remettre automatiquement S
   * après un changement de Color.
   *
   * On attend que Horizon + FulbiX aient fini
   * leur mise à jour avant de supprimer
   * cette sélection automatique.
   */
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {

      /*
       * Entre-temps, si la cliente a vraiment
       * cliqué sur une Size, on ne touche à rien.
       */
      if (
        confirmedSizeByForm.has(
          productForm
        )
      ) {
        return;
      }

      getSizeInputs(
        productForm
      ).forEach((input) => {
        input.checked = false;
        input.removeAttribute('checked');
        input.dataset.currentChecked = 'false';
        input.dataset.previousChecked = 'false';
      });

      showSelectSize(
        productForm
      );

      scheduleFulbixSizeVisualFix();
    });
  });

  return;
}


    const selectedSize =
      getSelectedSizeInput(
        productForm
      )?.value ?? null;


    /*
     * Si FulbiX change automatiquement
     * la Size pendant un changement de Color,
     * cette nouvelle Size n'est pas considérée
     * comme choisie par la cliente.
     */
    if (
      selectedSize !==
      confirmedSize
    ) {

      confirmedSizeByForm.delete(
        productForm
      );

      showSelectSize(
        productForm
      );

      scheduleFulbixSizeVisualFix();

      return;
    }


    /*
     * La cliente avait réellement choisi
     * cette Size.
     *
     * Exemple :
     *
     * M choisi
     * Red -> Black
     * Black/M disponible
     *
     * => Add To Cart reste actif.
     */
        if (
      result?.detail?.resource
        ?.available === true
    ) {
      variantReadyByForm.set(
        productForm,
        true
      );

      showAddToCart(
        productForm
      );
    }


    /*
     * Pour Sold Out / Unavailable :
     * ne rien forcer.
     *
     * Horizon garde son état natif.
     */

  } catch (error) {

    if (
      error?.name !==
      'AbortError'
    ) {

      console.warn(
        '[size-required-cta] Variant update failed:',
        error
      );
    }
  }
}


/* =========================================================
   INITIALIZATION
   ========================================================= */

function initSizeCTA() {

  document
    .querySelectorAll(
      'product-form-component'
    )
    .forEach(
      (productForm) => {

        if (
          getSizeInputs(
            productForm
          ).length === 0
        ) {
          return;
        }

        /*
         * Chaque chargement repart
         * sans Size confirmée par la cliente.
         */
        confirmedSizeByForm.delete(
  productForm
);

variantReadyByForm.set(
  productForm,
  false
);

/*
 * Au chargement, on regarde si au moins
 * une Size est réellement disponible.
 *
 * Cela évite d'activer notre CTA premium
 * sur un produit totalement Sold Out.
 */
const initialVariantAvailable =
  getSizeInputs(productForm).some(
    sizeInputIsAvailable
  );

variantAvailableByForm.set(
  productForm,
  initialVariantAvailable
);

showSelectSize(
  productForm
);

/*
 * À partir de maintenant, tout morph
 * Horizon du CTA sera stabilisé.
 */
startCTAStabilityObserver(
  productForm
);
      }
    );


  /*
   * Corriger uniquement l'état visuel
   * initial de FulbiX.
   */
  initFulbixSizeVisualFix();


  /*
   * Permettre à la correction de fonctionner
   * même si FulbiX charge après notre script.
   */
  startFulbixVisualObserver();
}


/* =========================================================
   EVENTS
   ========================================================= */
function handleWelcomeDiscountChange(event) {
  const productForm =
    getProductForm(event.target);

  if (!productForm) {
    return;
  }

  const {
    active,
    formattedPrice
  } = event.detail ?? {};

  if (
    active === true &&
    formattedPrice
  ) {
    discountedPriceByForm.set(
      productForm,
      formattedPrice
    );
  } else {
    discountedPriceByForm.delete(
      productForm
    );
  }

  stabilizeCTA(productForm);
}


document.addEventListener(
  'aurreva:welcome-discount-change',
  handleWelcomeDiscountChange
);

   document.addEventListener(
  'click',
  handleClick,
  true
);


document.addEventListener(
  'keydown',
  handleKeydown,
  true
);


document.addEventListener(
  'shopify:product:select',
  handleProductSelect
);


/*
 * Theme Editor Shopify.
 */
document.addEventListener(
  'shopify:section:load',
  () => {

    initSizeCTA();

    scheduleFulbixSizeVisualFix();
  }
);


document.addEventListener(
  'DOMContentLoaded',
  initSizeCTA
);